/**
 * Centered "preparing" veil shown while the worker pre-processes a freshly loaded
 * model (weld/adjacency/normals). On dense scans this takes several seconds, so it
 * needs to be obvious — a dark tint over the (still-orbitable) model with a spinner
 * and label. Tapping is already gated in the app; this is the visual signal.
 */
export function PreparingOverlay() {
  return (
    <div className="pf-preparing">
      <div className="pf-preparing-inner">
        <div className="pf-spinner" />
        <div className="pf-preparing-text">Preparing…</div>
      </div>
    </div>
  );
}
